import { jsx } from "react/jsx-runtime";
import IconLoading_module from "./IconLoading.module.js";
import { iconFactory } from "./Icon.js";
const IconLoading = iconFactory('IconLoading', /*#__PURE__*/ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "7.5",
    strokeWidth: "3",
    "data-icon-type": "stroke",
    fill: "transparent"
}), {
    className: IconLoading_module.spinner
});
export { IconLoading };
